import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import {
  FieldWrapper,
  FormlyFieldConfig,
  FormlyFieldProps,
} from '@ngx-formly/core';
import { Button } from 'primeng/button';
import { FORM_IMPORTS } from '../../_shared/_imports/form.import';

export interface SearchFieldProps extends FormlyFieldProps {
  buttonLabel: string;
  buttonSeverity?: typeof Button.prototype.severity;
  onClick: any;
  icon?: string;
}

@Component({
  selector: 'formly-wrapper-primeng-search',
  standalone: true,
  imports: [CommonModule, ...FORM_IMPORTS, Button],
  template: ` <div
    class="flex items-center gap-2 p-1 bg-surface-50 search-field border-2 rounded-[var(--p-inputtext-border-radius)] border-[var(--p-primary-color)]"
  >
    <div class="w-full">
      <ng-container #fieldComponent></ng-container>
    </div>
    <div>
      <p-button
        size="small"
        [label]="props.buttonLabel"
        [severity]="props.buttonSeverity ?? 'primary'"
        (onClick)="props.onClick(this)"
        [icon]="props.icon ?? ''"
      />
    </div>
  </div>`,
  styles: `
    :host ::ng-deep {
      .search-field {
        .p-inputtext {
          border: none;
          box-shadow: none;
        }
      }
    }
  `,
})
export class SearchFormlyWrapper extends FieldWrapper<
  FormlyFieldConfig<SearchFieldProps>
> {}
